import { NavigateFn } from "@tanstack/react-router";

let navigate: NavigateFn;

export function setNavigate(navigator: NavigateFn) {
  navigate = navigator;
}

export function getNavigate() {
  if (!navigate) {
    throw new Error("Navigate is not set. Ensure you call setNavigate in your app entry point.");
  }
  return navigate;
}
